import React from 'react';

import * as styles from './index.module.scss';

const BlogCategoryList = ({children}) => (
    <aside className={styles.blogCategoryListContainer}>
        <ul className={styles.blogCategoryList}>
            {children}
        </ul>
    </aside>
);

export default BlogCategoryList;